import { jsx as _jsx } from "react/jsx-runtime";
import { toClassName } from '../../utils/ClassNameUtils.js';
import { toSpacingClassName } from '../../utils/LayoutPropsUtils.js';
import { toTextStyleClassName } from '../../utils/TextStylePropsUtils.js';
export const Level = ({ sticky, children, ...props }) => {
    return (_jsx("nav", { className: toClassName('level', sticky && 'is-sticky-row', toSpacingClassName(props)), children: children }));
};
Level.displayName = 'Level';
Level.Left = ({ children }) => {
    return _jsx("div", { className: "level-left", children: children });
};
Level.Left.displayName = 'Level.Left';
Level.Right = ({ children }) => {
    return _jsx("div", { className: "level-right", children: children });
};
Level.Right.displayName = 'Level.Right';
Level.Item = ({ textStyle, children }) => {
    return (_jsx("div", { className: toClassName('level-item', textStyle && toTextStyleClassName(textStyle)), children: children }));
};
Level.Item.displayName = 'Level.Item';
//# sourceMappingURL=Level.js.map